module.exports = __webpack_public_path__ + "f91bcaaf712cb546e3d01a55e9dead69.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/4000_l_30.mp3
// module id = 440
// module chunks = 0